import { Pipe, PipeTransform } from '@angular/core'
import type { BaseProperty, Property } from '@app/shared/models/common-models'
import { LocalizeNumberPipe } from '@app/shared/pipes/localize-number/localize-number.pipe'
import { ResultGroupProperty } from '@app/shared/components/result-group/result-group.component'

/**
 * Formats a numeric value from a property model using the current locale and the propertys own settings.
 */
@Pipe({
  name: 'localizeNumberProperty',
  pure: false,
  standalone: false,
})
export class LocalizeNumberPropertyPipe implements PipeTransform {
  constructor(private localizePipe: LocalizeNumberPipe) {}

  /**
   * Format the numeric value from the property. You can use the valueToFormat-parameter to format other values than "Value",
   * for example: MinValue, MaxValue
   * @param property The property whos value we want to format
   * @param valueToFormat Either a key of the property object or a number which will be formatted
   */
  transform(property: BaseProperty, valueToFormat: keyof (Property & ResultGroupProperty) | number = 'Value'): string {
    let overrideValue: number = null

    if (typeof valueToFormat === 'number') {
      overrideValue = valueToFormat
    } else if (!property || !property.ValueType?.IsNumeric) {
      return ''
    }

    const options: Intl.NumberFormatOptions = {
      maximumFractionDigits: property.Decimals ?? 0,
      minimumFractionDigits: property.Decimals ?? 0,
    }

    return this.localizePipe.transform(overrideValue === null ? property[valueToFormat] : overrideValue, options)
  }
}
